import { useQuery } from "react-query";
import { getArea } from "../../../../../actions/Utilities/Area";

export default function useArea() {
  const {data, isFetching} = useQuery("GetArea", getArea, {
    refetchOnWindowFocus: false,
  });
  return {data, isFetching};
}
